// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"f536058c","24":"61641bf6","249":"c4cb8880","270":"110182d4","487":"7f62573e","586":"a52a49d6","756":"824b2c3a"}[chunkId] + ".chunk.js";
};